export default __webpack_public_path__ + "static/photo-sophie-d6f3b4bbe3f4b9cbcc969f1180a462f6.webp";